<template>
  <sds-card title="Informações Gerais">
    <v-row dense>
      <Info cols="12" md="3" label="Matéria" :value="info.deMateria" />
      <Info cols="12" md="9" label="Tipo da norma" :value="info.deTiponorma" />
      <Info cols="12" md="3" label="Número da norma" :value="info.nuNorma" />
      <Info
        cols="12"
        md="3"
        label="Data da norma"
        :value="info.dtLegislacaoFmt"
      />
      <Info cols="12" md="3" label="Ano" :value="info.nuAno" />
      <Info cols="12" label="Órgão expedidor" :value="info.nmOrgaoexpedidor" />
      <Info cols="12" label="Fonte" v-if="info.fontes && info.fontes.length">
        <ul>
          <li v-for="fonte in formatarFontes(info.fontes)" :key="fonte.label">
            <span>{{ fonte.label }}</span>

            <span
              v-for="(pagina, index) in fonte.paginas"
              :key="index + pagina.href"
            >
              <span v-if="index > 0">,</span>
              <component
                :href="pagina.href"
                :is="pagina.href ? 'a' : 'span'"
                target="_blank"
              >
                {{ pagina.label }}
              </component>
            </span>
          </li>
        </ul>
      </Info>

      <Info
        cols="12"
        link
        label="Arquivo (inteiro teor)"
        :value="info.nmArqInteiroTeor"
        :href="getURLArquivoInteriorTeor(info.hashCdLegislacao)"
      />
      <Info cols="12" :value="info.deSituacao" highlighted header="Situação" />
      <Info cols="12" :value="info.deLegislacao" highlighted header="Ementa" />
      <Info cols="12" header="Inteiro Teor" v-if="info.deNormaHtml">
        <div v-html="info.deNormaHtml" />
      </Info>
      <Info
        cols="12"
        header="Decisões"
        v-if="info.decisoes && info.decisoes.length"
      >
        <ul>
          <li v-for="decisao in info.decisoes" :key="decisao.cdDecisao">
            <a :href="getURLDownloadDecisao(decisao)">{{
              getLabelDecisao(decisao)
            }}</a>
          </li>
        </ul>
      </Info>

      <template v-if="info.referencias && info.referencias.length">
        <Info
          class="ma-0"
          v-for="(tipoVinculacao, index) in getTiposVinculacaoDasReferencias(
            info.referencias
          )"
          :label="tipoVinculacao.deTipoVinculacao"
          :key="tipoVinculacao.deTipoVinculacao"
          cols="12"
          :header="index === 0 ? 'Referências' : ''"
        >
          <ul>
            <li
              v-for="referencia in tipoVinculacao.referencias"
              :key="referencia.deTipoNorma"
            >
              <a :href="getURLReferencia(referencia)">
                {{ getLabelReferencia(referencia) }}
              </a>
            </li>
          </ul>
        </Info>
      </template>

      <Info
        cols="12"
        header="Referências Legislativas / Normativas"
        v-if="info.referenciasNL && info.referenciasNL.length"
      >
        <ul>
          <li v-for="(referencia, index) in info.referenciasNL" :key="index">
            {{ getLabelReferenciaNL(referencia) }}
          </li>
        </ul>
      </Info>
    </v-row>
  </sds-card>
</template>

<script lang="ts" setup>
import Info from '@/components/DynamicInfo.vue';
import { onMounted } from 'vue';
import { ConsultaLegislacaoStore } from '@/views/legislacao/store/ConsultaLegislacaoStore';
import { useRoute } from 'vue-router/composables';
import { storeToRefs } from 'pinia';
import {
  formatarFontes,
  getLabelDecisao,
  getLabelReferencia,
  getLabelReferenciaNL,
  getTiposVinculacaoDasReferencias,
  getURLArquivoInteriorTeor,
  getURLDownloadDecisao,
  getURLReferencia,
} from '@/utils/legislacaoUtils';

const { params } = useRoute();
const store = ConsultaLegislacaoStore();
const { informacoesGeraisLegislacao } = storeToRefs(store);
const info = informacoesGeraisLegislacao;

onMounted(() => {
  store.consultaLegislacao(params.cdLegislacao);
});
</script>
